export default __webpack_public_path__ + "static/media/ethereal2.0bdb70bd.jpeg";